export default "__VITE_ASSET__C_5ykfYP__"